"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowNumericEditor = /** @class */ (function (_super) {
    __extends(CardRowNumericEditor, _super);
    function CardRowNumericEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" };
        return _this;
    }
    CardRowNumericEditor.prototype.onValueChange = function (value) {
        if (this.props.onValueChanged) {
            this.props.onValueChanged(value);
        }
    };
    CardRowNumericEditor.prototype.getRequiredMark = function () {
        if (this.props.required) {
            //  if (!this.props.rules.isRequired) {
            return (React.createElement("span", { style: { color: "#FF0000", marginRight: "2px" } }, "*"));
            //  }
        }
        return (null);
    };
    CardRowNumericEditor.prototype.getErrorMessage = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return (React.createElement("div", { style: { color: "#FF0000", fontSize: "10px", textAlign: "left" } }, this.props.rules.errorMessage));
            }
        }
        return null;
    };
    CardRowNumericEditor.prototype.getTitleCSSStyle = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return {
                    width: "224px",
                    height: "32px",
                    color: "rgba(0,0,0,.65)",
                    textAlign: "center",
                    borderTopLeftRadius: 4,
                    borderBottomLeftRadius: 4,
                    backgroundColor: "#fafafa",
                    borderLeftWidth: 1,
                    borderLeftColor: "#FF0000",
                    borderLeftStyle: "solid",
                    borderTopWidth: 1,
                    borderTopColor: "#FF0000",
                    borderTopStyle: "solid",
                    borderRightWidth: 1,
                    borderRightColor: "#d9d9d9",
                    borderRightStyle: "solid",
                    borderBottomWidth: 1,
                    borderBottomColor: "#FF0000",
                    borderBottomStyle: "solid",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "31px"
                };
            }
        }
        return {
            width: "224px",
            height: "32px",
            color: "rgba(0,0,0,.65)",
            textAlign: "center",
            borderTopLeftRadius: "4px",
            borderBottomLeftRadius: "4px",
            backgroundColor: "#fafafa",
            borderWidth: "1px",
            // borderRightWidth: "0px",
            borderRightColor: "#d9d9d9",
            borderStyle: "solid",
            borderColor: "#d9d9d9",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "31px"
        };
    };
    CardRowNumericEditor.prototype.getInputCSSStyle = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return {
                    width: "calc( 100% - 224px )",
                    borderColor: "#FF0000",
                    borderStyle: "solid",
                    borderRightWidth: 1,
                    borderTopWidth: 1,
                    borderBottomWidth: 1,
                    borderLeftWidth: 0,
                    borderBottomRightRadius: 4,
                    borderTopRightRadius: 4,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderLeftColor: "transparent"
                };
            }
        }
        return {
            width: "calc( 100% - 224px )",
            borderLeftWidth: 0,
            borderBottomLeftRadius: 0,
            borderTopLeftRadius: 0,
            borderLeftColor: "#d9d9d9"
        };
    };
    /*private getStep() : number {
        if(this.props.step) {
            return this.props.step;
        } else {
            return 1;
        }
    }

    private getPrecision() : number {
        if(this.props.precision) {
            return this.props.precision;
        } else {
            return 1;
        }
    }*/
    CardRowNumericEditor.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            React.createElement(antd_1.Input.Group, { compact: true },
                React.createElement("div", { style: { display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" } },
                    React.createElement("div", { style: this.getTitleCSSStyle() },
                        this.getRequiredMark(),
                        this.props.texts.caption),
                    React.createElement(antd_1.InputNumber, { style: this.getInputCSSStyle(), placeholder: this.props.texts.placeholder, onChange: this.onValueChange.bind(this), value: this.props.values.value, min: this.props.values.min, max: this.props.values.max, disabled: this.props.disabled, step: this.props.step, precision: this.props.precision }))),
            this.getErrorMessage()));
    };
    return CardRowNumericEditor;
}(React.Component));
exports.default = CardRowNumericEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowNumericEditor.tsx
// module id = 29
// module chunks = 0